<template>
  <v-app>
    <v-container>
      <v-row justify="center" class="mb-3">
        <v-card width="200" height="200">
          <v-layout justify-center align-center fill-height>
            <figure>
              <v-img
                height="100"
                width="100"
                :src="user.userPic"
                class="rounded-circle"
              />

              <figcaption class="text-h6 text-center">
                {{ user.userName }}
              </figcaption>
            </figure>
          </v-layout>
        </v-card>
      </v-row>

      <v-row justify="center">
        <v-btn rounded color="primary" dark @click="passSenderId()">
          FRIENDS
        </v-btn>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: 'Test',
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  methods: {
    passSenderId() {  
      this.$router.push({ name: 'list' })
    },
  },
}
</script>
